// extracted by mini-css-extract-plugin
export var label = "_d0-5";
export var slideContainer = "_d0-0";
export var slider = "_d0-1";
export var sliderLg = "_d0-4";
export var sliderMd = "_d0-3";
export var sliderSm = "_d0-2";